import React, { FC, ReactNode } from "react";

export interface PanelHeadingProps {
  /** "Step 3 of 4", or a label like "Onboarding complete" on a result screen. */
  eyebrow: ReactNode;
  title: ReactNode;
  subtitle?: ReactNode;
  /** Result screens centre their heading and widen the subtitle. */
  centered?: boolean;
  className?: string;
}

/**
 * The eyebrow / serif title / subtitle stack every centre screen opens with.
 *
 * It belongs to the panel rather than the shell because the result screens set
 * their own labels and centre the whole block — the shell cannot know which.
 */
const PanelHeading: FC<PanelHeadingProps> = ({
  eyebrow,
  title,
  subtitle,
  centered = false,
  className = "",
}) => (
  <div className={`${centered ? "text-center" : ""} ${className}`}>
    <p className="text-[11px] font-extrabold uppercase tracking-[0.20em] text-gold min-[760px]:text-[12px]">
      {eyebrow}
    </p>

    <h2 className="mt-4 font-serif text-[34px] font-normal leading-[1.15] text-navy min-[760px]:text-[43px]">
      {title}
    </h2>

    {subtitle && (
      <p
        className={`mt-3 text-[15px] font-medium leading-[1.7] text-[#6f7a85] min-[760px]:text-[14.5px] ${
          centered ? "mx-auto max-w-[510px]" : ""
        }`}
      >
        {subtitle}
      </p>
    )}
  </div>
);

export default PanelHeading;
